export const AI_MODEL_LABELS = {
  'ai-resumo-gerencial': 'Resumo gerencial',
  'ai-resumo-spin': 'Resumo gerencial + SPIN',
  'ai-resumo-bant': 'Resumo gerencial + BANT',
  'ai-spin': 'SPIN',
  'ai-bant': 'BANT'
}

export const AI_MODEL_DEFAULT = 'ai-resumo-spin'

export function labelForAiModel (name) {
  return AI_MODEL_LABELS[name] || name
}



// WEBPACK FOOTER //
// ./src/utils/ai-model-labels.js